// extracted by mini-css-extract-plugin
export default {"info-placeholder":"static-field-renderer-module__info-placeholder__126la"};